/**
 * @generated SignedSource<<5852f5772b93c480f3602b012b9a3b53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ExpertType = "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "CONTRA_EXPERT_TEST" | "DESCRIPT_EXPERT" | "FLUTTERFLOW_EXPERT" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "JITTER_EXPERT" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SPLINE_EXPERT" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AddToListMenu_userAccount$data = {
  readonly workspaceForSelectedUserType: {
    readonly __typename: "ClientWorkspace";
    readonly userLists: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly displayName: string;
          readonly expertProgram: {
            readonly expertPartnership: ExpertType;
            readonly name: string;
          } | null;
          readonly id: string;
          readonly isUserProfileInList: boolean;
        };
      }>;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "AddToListMenu_userAccount";
};
export type AddToListMenu_userAccount$key = {
  readonly " $data"?: AddToListMenu_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddToListMenu_userAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userProfileId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddToListMenu_userAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "workspaceForSelectedUserType",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "groupNid": "NETWORK_LIST"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 200
                }
              ],
              "concreteType": "UserListConnection",
              "kind": "LinkedField",
              "name": "userLists",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserListUserProfileEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserList",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ExpertProgram",
                          "kind": "LinkedField",
                          "name": "expertProgram",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "expertPartnership",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "userProfileId",
                              "variableName": "userProfileId"
                            }
                          ],
                          "kind": "ScalarField",
                          "name": "isUserProfileInList",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "userLists(filter:{\"groupNid\":\"NETWORK_LIST\"},first:200)"
            }
          ],
          "type": "ClientWorkspace",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};

(node as any).hash = "5ef26a818f4c160a349d16cc6eea493e";

export default node;
